import { FlatPatientNote } from '@/store/modules/patient-note/getters'

export function getNoteId(note: FlatPatientNote): string {
  return `${note.patientId}---${note.userId}---${note.createdTimestamp}`
}
